// -- Endpoints --

// Regions
export const GET_REGIONS = '/api/regions';

export default GET_REGIONS;
